import React from "react";

import Container from "../../../../../../../../components/Container";
import SelectInput from "../../../../../../../../components/Inputs/SelectInput";
import TruncatedSelectInput from "../../../../../../../../components/Inputs/SelectInput/TruncatedSelectInput";
import Spacer from "../../../../../../../../components/Spacer";
import Text from "../../../../../../../../components/Text";
import TextWithTooltipInfoIcon from "../../components/TextWithInfoIcon";

import { ChartType } from "../../../../store/enums";

import useChartOptions from "../ChartHooks/UseChartOptions/useChartOptions";
import OptionSettings, { dataSeriesTooltipText, metricTooltipText } from "../shared/OptionSettings";

const { dataSeriesRangeOptions } = OptionSettings[ChartType.TrendlineChart];

const TrendlineChartOptions = () => {
	const { setYAxisColumnData, setDataSeries, visualizeOption, dataSeriesOptions, anyAxisOptions } = useChartOptions(
		ChartType.TrendlineChart
	);

	return (
		<>
			<SelectInput
				label="Time Series"
				labelProps={{ color: "neutral-9", weight: "semi-bold", size: "paragraph-3" }}
				results={dataSeriesOptions}
				value={visualizeOption?.dataSeries?.column}
				menuPortalTarget={document.body}
				menuPosition="fixed"
				onChange={(option) => setDataSeries("column", option.value)}
				info={{
					title: "Time Series",
					message: dataSeriesTooltipText,
					titleBottomLine: true,
				}}
			/>
			<Container marginTop="3px">
				<Container centerVertical marginBottom="5px" width={79}>
					<Text size="caption" color="neutral-9" weight="regular">
						Granularity
					</Text>
				</Container>
				<Container block>
					<SelectInput
						value={visualizeOption?.dataSeries?.rangeOption || "year"}
						results={dataSeriesRangeOptions}
						menuPortalTarget={document.body}
						menuPosition="fixed"
						onChange={(option) => setDataSeries("rangeOption", option.value)}
					/>
				</Container>
			</Container>
			<Container marginTop="3px" column>
				<TextWithTooltipInfoIcon text="Metric" tooltipMessage={metricTooltipText} />
				<Spacer height={1} />
				<TruncatedSelectInput
					value={visualizeOption?.yAxis?.column}
					results={anyAxisOptions}
					menuPortalTarget={document.body}
					menuPosition="fixed"
					onChange={(option) => setYAxisColumnData("column", option.value)}
				/>
			</Container>
		</>
	);
};

export default TrendlineChartOptions;
